/** 从登录/用户信息对象中取出头像地址（兼容多种后端字段名） */
const KEYS = [
  "avatarUrl",
  "avatar",
  "headImg",
  "headimg",
  "head_url",
  "image",
  "photo",
  "portrait",
  "icon",
  "wxAvatar",
  "avatar_url",
];

export function pickUserAvatarUrl(obj) {
  if (!obj || typeof obj !== "object") return "";
  for (const k of KEYS) {
    const v = obj[k];
    if (v != null && String(v).trim()) return String(v).trim();
  }
  return "";
}
